module.exports = __webpack_public_path__ + "img/Bill1.0e690ac0.png";